import { Component, EventEmitter, Output } from '@angular/core';


@Component({
	selector: 'bo-reporting-list-presentation',
	template: require("./bo-reporting-list.presentation.html"),
	styles: [require("../reporting-list/reporting-list.presentation.scss")]
})

export class BookingOfficeReportingListPresentation {

	@Output() vvkSteAbrClicked: EventEmitter<any> = new EventEmitter();

	vvkAbrechnungVon;
	vvkAbrechnungBis;
	vvkSteAbrAbrechnungssatz: string;

	downloadVorverkaufsstellenabrechnung() {
		this.vvkSteAbrClicked.emit({
			from: this.vvkAbrechnungVon,
			to: this.vvkAbrechnungBis,
			abrechnungsSatz: this.vvkSteAbrAbrechnungssatz,
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/reporting/bo-reporting-list/bo-reporting-list.presentation.ts